import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["onDblclick"]
const _hoisted_5 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_6 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 2,
  class: "pl-2"
}
const _hoisted_9 = {
  key: 0,
  class: "flex items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDelete = _resolveComponent("ConfirmDelete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (t, i) => {
      return (_openBlock(), _createElementBlock("span", {
        key: i,
        class: _normalizeClass(["border-b-2 p-2 flex mr-3", {'border-b-next-orange': i===_ctx.Radio}])
      }, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            type: "radio",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Radio) = $event)),
            value: i
          }, null, 8, _hoisted_2), [
            [_vModelRadio, _ctx.Radio]
          ]),
          (!_ctx.Readonly && _ctx.editing_index === i && this.isEditing)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                "onUpdate:modelValue": ($event: any) => ((t.titolo) = $event),
                ref_for: true,
                ref: "mod",
                onKeydown: [
                  _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.disableEditable && _ctx.disableEditable(...args)), ["prevent"]), ["enter"])),
                  _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.disableEditable && _ctx.disableEditable(...args)), ["prevent"]), ["tab"]))
                ]
              }, null, 40, _hoisted_3)), [
                [_vModelText, t.titolo]
              ])
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                onDblclick: ($event: any) => (_ctx.enableEditable(i)),
                class: _normalizeClass(["select-none cursor-pointer", {'font-bold text-next-orange': i===_ctx.Radio}])
              }, _toDisplayString(t.titolo), 43, _hoisted_4))
        ]),
        (_ctx.isEditing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("i", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.disableEditable && _ctx.disableEditable(...args))),
                class: "text-sm icon-floppy cursor-pointer hover:text-next-orange"
              })
            ]))
          : (!_ctx.Readonly && !_ctx.Disabled && i===_ctx.Radio)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createElementVNode("i", {
                  onClick: ($event: any) => (_ctx.$emit('duplicatab', i)),
                  class: "text-sm icon-duplica cursor-pointer hover:text-next-orange"
                }, null, 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
        (!_ctx.Readonly && !_ctx.Disabled && _ctx.allowDelete)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _createVNode(_component_ConfirmDelete, {
                onCancella: ($event: any) => (_ctx.cancella(i))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "text-sm icon-x" }, null, -1)
                ])),
                _: 2
              }, 1032, ["onCancella"])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    (!_ctx.Readonly && !_ctx.Disabled)
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
          _createElementVNode("i", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('addtab'))),
            class: "icon-croce_cerchiata cursor-pointer"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}